module.exports = __webpack_public_path__ + "img/shield.b471038e.png";